import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist'
import cart from './modules/cart'
import account from './modules/account'
import payments from './modules/payments'
import shipments from './modules/shipments'
import restaurants from './modules/restaurants'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
})

export default new Vuex.Store({
  modules: {
    account,
    payments,
    shipments,
    restaurants,
    cart,
  },
  state: {
    expiryDate: new Date(),
  },

  getters: {
    isExpired: state => (new Date(state.expiryDate) < new Date()),
  },
  // Actions that alter the state of the store
  mutations: {
    setExpiryDate: (state) => {
      // Create a date
      const date = new Date();
      const minutesToAdd = 3;
      //Hết hạn sau 5 phút
      date.setDate(date.getTime() + minutesToAdd * 60000);
      // Set the state
      state.expiryDate = date;
    },
  },
  plugins: [vuexLocal.plugin]
});



// WEBPACK FOOTER //
// ./src/store/index.js